<template>
    <div class="side-class">
        <div class="unit-lable">
            <div class="lable-icon">
                <i class="el-icon-s-data"></i>
            </div>
            <div class="lable-name">排行统计</div>
        </div>
        <div class="hot-container">
            <div
                class="side-single-hot"
                v-for="(hot,index) in articleList"
                :key="index"
                @click="toDetail(hot)"
                v-if="index < 6"
            >
                <div class="hot-content" :title="hot.title">{{ hot.title }}</div>
                <div class="hot-icon">
                    <span>
                        <i class="el-icon-view"></i>
                        {{hot.views}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                articleList: []
            };
        },
        created() {
            this.getHotArtList();
        },
        methods: {
            getHotArtList() {
                this.httpGet(this.$root.getHotArticle, {})
                    .then(result => {
                        this.articleList.push(...result.list);
                    })
                    .catch(err => {
                        console.error('getHotArticle-err', err);
                    });
            },
            toDetail(item) {
                if (item.id !== '') {
                    this.httpGet(this.$root.getCrumbsDetail, {
                        id: item.id,
                        type: 'article'
                    })
                        .then(result => {
                            // 面包屑
                            let breadObj = [
                                {
                                    id: result.id,
                                    path: 'article-list?id=' + result.id,
                                    name: result.title
                                }
                            ];
                            if (result.children.length) {
                                breadObj.push({
                                    id: result.children.id,
                                    path:
                                        'article-list?id=' + result.children.id,
                                    name: result.children.title
                                });
                            }
                            this.$store.commit('setBreadArr', breadObj);
                        })
                        .catch(err => {
                            console.error('getCrumbsDetail-err', err);
                        });
                    this.$router.push({
                        name: 'article-details',
                        query: {
                            id: item.id
                        }
                    });
                }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .side-class {
        padding: 12px 24px;
    }

    .unit-lable {
        height: 44px;
        flex-x(flax-start);

        .lable-icon {
            i {
                font-size: 17px;
                color: #4093FF;
            }
        }

        .lable-name {
            width: 64px;
            height: 21px;
            font-size: 16px;
            color: gray3;
            line-height: 21px;
            margin-left: 5px;
        }
    }

    .hot-container {
    }

    .side-single-hot {
        margin: 10px 0;
        flex-y(flex-start, flex-start);

        .hot-content {
            width: 100%;
            max-width 232px
            max-height 34px
            font-size: 14px;
            color: gray6;
            line-height: 17px;
            multi(2);
        }

        .hot-content:hover {
            color: #4093FF;
        }

        .hot-icon {
            margin-top: 5px;
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 17px;

            i {
                font-size: 12px;
                color: #9DA4B3;
            }
        }
    }

    .side-single-hot:hover {
        cursor: pointer;
        // color: blue;
        // color: #4093FF;
    }

    .more {
        more();
    }

    .more:hover {
        cursor: pointer;
    }
</style>
